import { render, staticRenderFns } from "./text-section.vue?vue&type=template&id=7ec2f6b2"
import script from "./text-section.vue?vue&type=script&lang=js"
export * from "./text-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports